<template>
  <div>
    <div class="form-group">
      <label class="form-label" for="text">Текст</label>
      <textarea class="form-control" rows="3" v-model="text" id="text"></textarea>
    </div>

    <div class="btn-group" role="group" aria-label="Basic example">
      <button v-if="isNew" type="button" class="btn btn-primary text-nowrap" @click="submitForm">
        <i class="fas fa-plus"></i>
        Добавить заметку
      </button>
      <button v-else type="button" class="btn btn-primary text-nowrap" @click="submitForm">
        <i class="fas fa-edit"></i>
        Редактировать заметку
      </button>

      <button type="button" class="btn text-nowrap btn-light" @click="returnToList">
        <i class="fas fa-ban"></i>
        Отменить
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ClientNoteForm',

  props: ['note'],

  data() {
    return {
      text: '',
      error: '',
    };
  },

  created() {
    if (!this.isNew) {
      this.text = this.note.text;
    }
  },

  computed: {
    isNew() {
      return typeof this.note === 'undefined';
    },
  },

  methods: {
    async submitForm() {
      this.$emit('submit', this.text);
    },

    returnToList() {
      this.$emit('cancel');
    },
  },
};
</script>
